/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config/animation";

/* ICONS */
import { FaQuoteRight } from "react-icons/fa6";

const Testimonials = () => {
  return (
    <motion.div variants={animation} className="py-6 xl:py-12 lg:py-12">
      <div className="container">
        <h5 className="text-base font-source font-normal text-primary">
          TESTIMONIALS
        </h5>
        <h2 className="mt-2 text-2xl xl:text-3xl lg:text-3xl font-source font-bold text-black tracking-tight">
          What our students say about us
        </h2>
        <div className="mt-5 grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-5 xl:gap-10 lg:gap-10">
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5 relative overflow-hidden">
              <p className="mt-1 text-base font-source font-normal text-greyText">
                John's class was excellent. John has a wealth of knowledge and
                presents facts in the simplest formats. Even after class, he
                allowed us to stay around to ask any questions, clear doubts,
                and gain knowledge. Absolutely good!
              </p>

              <div className="absolute -top-4 -right-2">
                <FaQuoteRight className="w-14 h-14 text-primary/20" />
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <div className="h-full bg-white border border-[#E5E5E5] rounded-lg shadow p-5 relative overflow-hidden">
              <p className="mt-1 text-base font-source font-normal text-greyText">
                I'm happy to announce that I successfully passed both my
                national and state exams. Thank you for offering a fantastic
                education and for meeting with me and speaking with me at first;
                your genuine interest made a huge impact.
              </p>

              <div className="absolute -top-4 -right-2">
                <FaQuoteRight className="w-14 h-14 text-primary/20" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Testimonials;
